import script from "./IfcViewerToolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./IfcViewerToolbar.vue?vue&type=script&setup=true&lang=ts"

import "./IfcViewerToolbar.vue?vue&type=style&index=0&id=535878b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535878b4"]])

export default __exports__